import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminapiService } from '../../shared/services/adminapi.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-admin-forgot-password',
  templateUrl: './admin-forgot-password.component.html',
  styleUrls: ['./admin-forgot-password.component.scss']
})
export class AdminForgotPasswordComponent {
  formSubmitting=false;
  email:any;
  otpsent:any;
  otp:any;
  password:any;
  emailerror=false;
  passworderror=false;
  otperror=false;
  time: number = 0;
  interval:any;
  sendingotp=false;
  
  constructor(public adminApi: AdminapiService, private toastrService: ToastrService, public router: Router) {
    
  }

  removeErrors(){
    this.emailerror=false;
    this.passworderror=false;
    this.otperror=false;
  }

  sendOtp() {
    if(!this.sendingotp){
      if (!this.email || this.email=='' || !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email)) {
        this.emailerror = true
      } else {
        this.sendingotp=true;
        let params = {
          email:this.email
        }
        this.adminApi.sendotp(params).subscribe((data: any) => {
          if (data.success) {
            this.time=60;
            this.interval = setInterval(() => {
                if(this.time > 0) {
                    this.time--;
                } else {
                  clearInterval(this.interval);
                }
            },1000)
            this.otpsent=true;
            this.toastrService.success(data.message);
            //this.adminApi.setSession(data);
            //this.router.navigateByUrl('/');
          } else {
            this.toastrService.error(data.message);
          }
          this.sendingotp=false;
        },
        error => {
          this.toastrService.error("unable to handle response");
          this.sendingotp=false;
        });
      }
    }
  }

  changePassword(){
    if(!this.formSubmitting){
      if (!this.email || this.email=='' || !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email)) {
        this.emailerror = true
      }else if(!this.otp || this.otp.length<5){
        this.otperror = true
      }else if(!this.password || this.password.length<8){
        this.passworderror = true
      } else {
        this.formSubmitting=true;
        let params = {
          email:this.email,
          otp:this.otp,
          password:this.password
        }
        this.adminApi.resetpassword(params).subscribe((data: any) => {
          if (data.success) {
            this.toastrService.success(data.message);
            //this.adminApi.setSession(data);
            this.router.navigateByUrl('/admin/login');
          } else {
            this.toastrService.error(data.message);
          }
          this.formSubmitting=false;
        },
        error => {
          this.toastrService.error("unable to handle response");
          this.formSubmitting=false;
        });
      }
    }
  }

}
